import { createContext, useContext } from 'react';

interface ModalContextValue {
  onClose?: () => void;
}

const ModalContext = createContext<ModalContextValue | null>(null);

export const useModalContext = (): ModalContextValue | null => {
  return useContext(ModalContext);
};

export default ModalContext;
